import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1962266a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal"
}



interface Props {
  visible: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Modal',
  props: {
    visible: { type: Boolean }
  },
  emits: ['close'],
  setup(__props: any, { emit: emits }) {





const close = () => {
  emits('close');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (__props.visible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass(["modal-content", {'modal-open': __props.visible}]),
            onClick: _cache[0] || (_cache[0] = (e) => e.stopPropagation())
          }, [
            _renderSlot(_ctx.$slots, "default")
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})